// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__ujlmm","contact_link":"styles_contact_link__NWNkG","icon":"styles_icon__Yd5l3"};